module.exports = __webpack_public_path__ + "static/img/carl-lomas.14a654f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/testimonial/carl-lomas.png
// module id = xEJi
// module chunks = 38